var spqD={name:'',goal:'',hmode:'cm',hcm:175,hft:5,hin:9,wmode:'kg',wkg:80,wst:12,wlb:8,bmi:0,bband:'',flags:[],safety:'',fmt:'',rpref:'',fam:'',nxts:''};
var spqCat={
  'recovery':[{n:'BPC-157',d:'Body protection and tissue repair',p:98.40,pmg:9.84,url:'/products/bpc-157'},{n:'TB-500',d:'Tissue repair and wound healing',p:98.40,pmg:9.84,url:'/products/tb-500'}],
  'gh-anti-ageing':[{n:'Ipamorelin',d:'GH release and anti-ageing support',p:92.40,pmg:9.24,url:'/products/ipamorelin'},{n:'CJC-1295',d:'GHRH analogue for sustained GH release',p:134.40,pmg:13.44,url:'/products/cjc-1295'},{n:'Tesamorelin',d:'Visceral fat reduction and metabolic',p:152.40,pmg:15.24,url:'/products/tesamorelin'}],
  'weight-management':[{n:'AOD-9604',d:'Fat metabolism and lipolysis',p:108.00,pmg:10.80,url:'/products/aod-9604'},{n:'Retatrutide',d:'Triple-receptor metabolic compound',p:224.40,pmg:22.44,url:'/products/retatrutide'}],
  'longevity':[{n:'GHK-Cu',d:'Skin rejuvenation and longevity',p:92.40,pmg:9.24,url:'/products/ghk-cu'},{n:'NAD+',d:'Cellular energy and sirtuin activation',p:242.40,pmg:24.24,url:'/products/nad'},{n:'MOTS-C',d:'Mitochondrial optimisation and metabolic',p:116.40,pmg:11.64,url:'/products/mots-c'}],
  'nootropics':[{n:'Semax',d:'Cognitive enhancement and neuroprotection',p:102.00,pmg:10.20,url:'/products/semax'},{n:'Selank',d:'Anxiolytic and cognitive clarity',p:80.40,pmg:8.04,url:'/products/selank'}],
  'sleep-recovery':[{n:'DSIP',d:'Sleep regulation and neuromodulatory',p:108.00,pmg:10.80,url:'/products/dsip'}]
};
var spqGL={'recovery':'Recovery','gh-anti-ageing':'GH / Anti-Ageing','weight-management':'Weight Management','longevity':'Longevity','nootropics':'Nootropics','sleep-recovery':'Sleep & Recovery'};
var spqProg={'intro':0,'s0':10,'s1':22,'s2':34,'s3':46,'s4':56,'s5':66,'s6':76,'s7':86,'s8':93,'result':100};
var spqCurStep='intro';

function spqTo(id){
  document.querySelectorAll('.spq-step').forEach(function(s){s.classList.remove('active');});
  document.getElementById('spq-'+id).classList.add('active');
  spqCurStep=id;
  spqRefresh();
  window.scrollTo({top:0,behavior:'smooth'});
}

function spqR(el,key,val){
  var g=el.closest('.spq-opts,.spq-opts-2');
  g.querySelectorAll('.spq-opt').forEach(function(o){o.classList.remove('sel');});
  el.classList.add('sel');
  spqD[key]=val;
  var s=el.closest('.spq-step').id.replace('spq-','');
  var nb=document.getElementById('spq-n'+s.replace('s',''));
  if(nb)nb.disabled=false;
  spqRefresh();
}

function spqFlag(el,val){
  if(val==='None of these'){
    document.querySelectorAll('#spq-flags .spq-opt').forEach(function(o){o.classList.remove('sel');});
    if(!el.classList.contains('sel')){el.classList.add('sel');spqD.flags=['None of these'];}
    else{el.classList.remove('sel');spqD.flags=[];}
    spqRefresh();return;
  }
  var noneEl=document.querySelector('#spq-flags .spq-opt:nth-child(6)');
  if(noneEl)noneEl.classList.remove('sel');
  el.classList.toggle('sel');
  if(el.classList.contains('sel')){spqD.flags.push(val);}
  else{spqD.flags=spqD.flags.filter(function(f){return f!==val;});}
  spqD.flags=spqD.flags.filter(function(f){return f!=='None of these';});
  spqRefresh();
}

function spqHUnit(m){
  spqD.hmode=m;
  document.getElementById('spq-hcm').style.display=m==='cm'?'':'none';
  document.getElementById('spq-hftin').style.display=m==='ftin'?'':'none';
  document.getElementById('spq-hcmbtn').classList.toggle('on',m==='cm');
  document.getElementById('spq-hftbtn').classList.toggle('on',m==='ftin');
  spqBmi();
}
function spqWUnit(m){
  spqD.wmode=m;
  document.getElementById('spq-wkg').style.display=m==='kg'?'':'none';
  document.getElementById('spq-wstlb').style.display=m==='stlb'?'':'none';
  document.getElementById('spq-wkgbtn').classList.toggle('on',m==='kg');
  document.getElementById('spq-wstbtn').classList.toggle('on',m==='stlb');
  spqBmi();
}
function spqBmi(){
  var hm=spqD.hmode==='cm'?spqD.hcm/100:(spqD.hft*12+spqD.hin)*0.0254;
  var wk=spqD.wmode==='kg'?spqD.wkg:(spqD.wst*14+spqD.wlb)*0.453592;
  if(hm>0&&wk>0){
    var b=wk/(hm*hm);spqD.bmi=Math.round(b*10)/10;
    spqD.bband=b<18.5?'<18.5':b<25?'18.5-25':b<30?'25-30':b<35?'30-35':'35+';
  }
  spqRefresh();
}
function spqBmiFt(){spqBmi();}
function spqBmiSt(){spqD.wkg=(spqD.wst*14+spqD.wlb)*0.453592;spqBmi();}
function spqSyncSlider(){var s=document.getElementById('spq-wslider');if(s){s.value=spqD.wkg;spqSliderBg(s);}}
function spqSliderBg(s){
  var pct=(s.value-s.min)/(s.max-s.min)*100;
  s.style.background='linear-gradient(to right,#3a7bd5 0%,#3a7bd5 '+pct+'%,rgba(0,0,0,.14) '+pct+'%,rgba(0,0,0,.14) 100%)';
}
function spqMatchCount(){
  if(!spqD.goal||!spqCat[spqD.goal])return'?';
  var c=spqCat[spqD.goal].length;
  if(spqD.flags.length>0&&spqD.flags.indexOf('None of these')===-1)c=Math.max(1,c-1);
  return c;
}
function spqPanelHtml(step){
  var prog=spqProg[step]||0;
  var mc=spqMatchCount();
  var flbl=spqD.flags.length===0?'&#x2014;':spqD.flags.length+' noted';
  var fmlbl={single:'Single',combined:'Combined stack',open:'Open to either',unsure:'Not sure'}[spqD.fmt]||'&#x2014;';
  var rplbl={'one-pick':'One pick','few-options':'A few options','browse-all':'Browse all'}[spqD.rpref]||'&#x2014;';
  var famlbl={new:'New',somewhat:'Somewhat familiar',very:'Very familiar'}[spqD.fam]||'&#x2014;';
  var glbl=spqGL[spqD.goal]||'&#x2014;';
  var bmilbl=spqD.bmi>0?spqD.bmi+' ('+spqD.bband+')':'&#x2014;';
  return '<p class="spq-p-title">&#x2014; YOUR PROFILE</p>'+
    '<p class="spq-p-sub">Building as you answer</p>'+
    '<span class="spq-p-mlbl">MATCHING CATALOGUE</span>'+
    '<p style="margin:4px 0 12px"><span class="spq-p-mnum">'+mc+'</span> <span class="spq-p-munit">match'+(mc!==1&&mc!=='?'?'es':'')+'</span></p>'+
    '<hr class="spq-p-hr">'+
    '<div class="spq-p-row"><span class="spq-p-key">NAME</span><span class="spq-p-val">'+(spqD.name||'&#x2014;')+'</span></div>'+
    '<div class="spq-p-row"><span class="spq-p-key">SHIP TO</span><span class="spq-p-val">UK</span></div>'+
    '<div class="spq-p-row"><span class="spq-p-key">BMI</span><span class="spq-p-val">'+bmilbl+'</span></div>'+
    '<div class="spq-p-row"><span class="spq-p-key">GOAL</span><span class="spq-p-val">'+glbl+'</span></div>'+
    '<div class="spq-p-row"><span class="spq-p-key">FLAGS</span><span class="spq-p-val">'+flbl+'</span></div>'+
    '<div class="spq-p-row"><span class="spq-p-key">FORMAT</span><span class="spq-p-val">'+fmlbl+'</span></div>'+
    '<div class="spq-p-row"><span class="spq-p-key">RESULT</span><span class="spq-p-val">'+rplbl+'</span></div>'+
    '<div class="spq-p-row"><span class="spq-p-key">FAMILIARITY</span><span class="spq-p-val">'+famlbl+'</span></div>'+
    '<div class="spq-p-prog-hd"><span>PROGRESS</span><span>'+prog+'%</span></div>'+
    '<div class="spq-p-bar"><div class="spq-p-fill" style="width:'+prog+'%"></div></div>';
}
function spqRefresh(){
  ['s0','s1','s2','s3','s5','s6','s7'].forEach(function(s){
    var p=document.getElementById('spq-p'+s.replace('s',''));
    if(p)p.innerHTML=spqPanelHtml(s);
  });
}
function spqGetRec(){
  var cat=spqD.goal||'recovery';
  var prods=spqCat[cat]||spqCat['recovery'];
  var primary=prods[0];
  if(cat==='weight-management'&&spqD.bmi>35)primary=prods[1]||prods[0];
  if(cat==='nootropics'&&spqD.fam==='new')primary=prods.find(function(p){return p.n==='Selank';})||prods[0];
  if(cat==='longevity'&&spqD.fam==='very')primary=prods.find(function(p){return p.n==='MOTS-C';})||prods[0];
  return{primary:primary,all:prods,cat:cat};
}
function spqResult(){
  var rec=spqGetRec();var p=rec.primary;
  var nm=spqD.name?spqD.name.charAt(0).toUpperCase()+spqD.name.slice(1):null;
  document.getElementById('spq-rname').textContent=(nm?nm+', ':'')+'YOUR RESULT';
  document.getElementById('spq-rtitle').textContent='Start here: '+p.n+'.';
  document.getElementById('spq-rdesc').textContent=p.n+' is the recommended entry point for '+spqGL[rec.cat].toLowerCase()+' research. All '+rec.all.length+' related compound'+(rec.all.length!==1?'s':'')+' are compared below.';
  var bmiT=spqD.bmi>0?'BMI '+spqD.bmi:null;
  var famT={new:'Beginner',somewhat:'Experienced',very:'Advanced'}[spqD.fam];
  var th='<div class="spq-tag">'+spqGL[rec.cat].toUpperCase()+'</div>';
  if(bmiT)th+='<div class="spq-tag">'+bmiT+'</div>';
  if(famT)th+='<div class="spq-tag">'+famT.toUpperCase()+'</div>';
  document.getElementById('spq-rtags').innerHTML=th;
  var famDesc={new:'someone new to peptide research',somewhat:'an experienced researcher',very:'an advanced researcher'}[spqD.fam]||'a researcher';
  document.getElementById('spq-rcard').innerHTML=
    '<p class="spq-pc-eyebrow">&#x2014; RECOMMENDED FOR YOU</p>'+
    '<div class="spq-pc-row"><span class="spq-pc-name">'+p.n+'</span><span class="spq-pc-price">&#xA3;'+Math.round(p.p)+'</span></div>'+
    '<p class="spq-pc-desc">'+p.d+'</p>'+
    '<p class="spq-pc-note">Matched to your '+spqGL[rec.cat].toLowerCase()+' goal as '+famDesc+'.</p>'+
    '<a class="spq-pc-buy" href="'+p.url+'">BUY '+p.n+' &middot; &#xA3;'+Math.round(p.p)+' &#x2192;</a>'+
    '<div class="spq-pc-acts">'+
    '<a class="spq-pc-btn" href="'+p.url+'">ADD TO BAG</a>'+
    '<a class="spq-pc-btn" href="'+p.url+'">Read full details</a>'+
    '<button class="spq-pc-lnk" onclick="spqReset()">Re-take quiz</button>'+
    '</div>';
  var tbl='<p class="spq-tbl-lbl">&#x2014; SIDE-BY-SIDE COMPARISON</p>'+
    '<table class="spq-tbl"><thead><tr><th>COMPOUND</th><th>PURITY</th><th>VIAL FROM</th><th>FORMAT</th><th>&#xA3;/MG</th><th>PRICE FROM</th></tr></thead><tbody>';
  rec.all.forEach(function(pr){
    var bm=pr.n===p.n;
    tbl+='<tr'+(bm?' class="bm"':'')+'><td><strong>'+pr.n+'</strong>'+(bm?'<span class="spq-tbl-bm">BEST MATCH</span>':'')+'<span class="spq-tbl-note">'+pr.d+'</span></td><td>&#x2265;99%</td><td>10mg</td><td>Lyophilised</td><td>&#xA3;'+pr.pmg.toFixed(2)+'</td><td>&#xA3;'+Math.round(pr.p)+'</td></tr>';
  });
  tbl+='</tbody></table><p style="font-size:.73rem;color:#888;margin:6px 0 24px">All compounds: &#x2265;99% HPLC purity &middot; COA every order &middot; Tracked international shipping.</p>';
  document.getElementById('spq-rtable').innerHTML=tbl;
  spqTo('result');
}
function spqReset(){
  spqD={name:'',goal:'',hmode:'cm',hcm:175,hft:5,hin:9,wmode:'kg',wkg:80,wst:12,wlb:8,bmi:0,bband:'',flags:[],safety:'',fmt:'',rpref:'',fam:'',nxts:''};
  document.querySelectorAll('.spq-opt').forEach(function(o){o.classList.remove('sel');});
  document.querySelectorAll('.spq-next').forEach(function(b){b.disabled=true;});
  document.getElementById('spq-c1').checked=false;
  document.getElementById('spq-startbtn').disabled=true;
  spqTo('intro');
}
document.addEventListener('DOMContentLoaded',function(){
  var s=document.getElementById('spq-wslider');if(s)spqSliderBg(s);
  spqBmi();
});